import React, { useState } from "react";
import Modal from "../shared/Modal";
import { PolicyProjectType } from "winslow-core";
import "./ModalCreatePolicyProject.css";
import { Selector } from "../common/Selector";
import { getPolicyProjectTypeLabel } from "winslow-core";
import ActionButton from "../common/ActionButton";
import PolicyStudioUploadFileButton from "./components/PolicyStudioUploadFileButton";
import { Button } from "../../ds2/components";

interface ModalCreatePolicyProjectFromFileProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (file: File, type: PolicyProjectType) => void;
}

const policyProjectTypeOptions = Object.values(PolicyProjectType)
  .map((type) => ({
    value: type,
    label: getPolicyProjectTypeLabel(type),
  }))
  .sort((a, b) => {
    return a.label.localeCompare(b.label);
  });

export const ModalCreatePolicyProjectFromFile: React.FC<
  ModalCreatePolicyProjectFromFileProps
> = ({ isOpen, onClose, onSubmit }) => {
  const [selectedType, setSelectedType] = useState<PolicyProjectType | null>(
    null
  );
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const onChange = (value: string) => {
    setSelectedType(value as PolicyProjectType);
  };

  const handleSubmit = () => {
    if (selectedType && selectedFile) {
      onSubmit(selectedFile, selectedType);
      onClose();
      setSelectedFile(null);
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{
        width: "500px",
      }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="modal-create-policy-project">
        <div className="modal-create-policy-project-title">
          <h2>Create New Policy Project</h2>
        </div>
        <div className="modal-create-policy-project-body">
          <div className="modal-create-policy-project-content">
            <Selector
              options={policyProjectTypeOptions}
              onChange={onChange}
              value={selectedType || ""}
              placeholder="Select a policy type"
            />
          </div>
          <div className="modal-create-policy-project-file-upload">
            <PolicyStudioUploadFileButton
              label="Upload File"
              variant="primary"
              onFileSelect={(file) => setSelectedFile(file)}
            />

            {selectedFile && (
              <div className="modal-create-policy-project-file-upload-file-name">
                <span className="modal-create-policy-project-file-upload-file-name-text">
                  {selectedFile.name}
                </span>
                <span
                  className="modal-create-policy-project-file-upload-remove"
                  onClick={handleRemoveFile}>
                  ×
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="modal-create-policy-project-buttons">
          <Button label="Cancel" variant="primary" onClick={onClose} />
          <Button
            label="Create Project"
            variant="tertiary"
            onClick={handleSubmit}
            disabled={!selectedType || !selectedFile}
          />
        </div>
      </div>
    </Modal>
  );
};
